<mat-card>
  <mat-card-header class="titreFrm">
    <mat-card-title>{{'paramétre heure'.toUpperCase()}}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
  <mat-card class="example-card">
    <mat-card-content>
      <div *ngIf="exist;else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      <form class="example-form" #f="ngForm">
        <div class="btn">
          <button (click)="enregistrer(f)" [disabled]="disabledBtnEnregistrer" mat-raised-button class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
        </div>
          <mat-form-field     appearance="outline"  >
            <mat-label>Ecart</mat-label>
              <input matInput type="number" name="avtHeure_Ecart" #avtHeure_Ecart="" [(ngModel)]="data.avtHeure_Ecart"
                placeholder="Ecart" required>
            </mat-form-field>
            <mat-form-field     appearance="outline"  >
              <mat-label>Heure de débue AM</mat-label>
              <input matInput type="time" name="avtHeureAM_Deb" #avtHeureAM_Deb="ngModel" [(ngModel)]="data.avtHeureAM_Deb"
                placeholder="Heure de débue AM" required>
            </mat-form-field>
            <mat-form-field     appearance="outline"  >
              <mat-label>Heure de fin AM</mat-label>
              <input matInput type="time" name="avtHeureAM_Fin" #avtHeureAM_Fin="" [(ngModel)]="data.avtHeureAM_Fin"
                placeholder="Heure de fin AM" required>
            </mat-form-field>
              <mat-form-field     appearance="outline"  >
                <mat-label>Heure de débue PM</mat-label>
                <input matInput type="time" name="avtHeurePM_Deb" #avtHeurePM_Deb="ngModel" [(ngModel)]="data.avtHeurePM_Deb"
                  placeholder="Heure de débue PM" required>
              </mat-form-field>
              <mat-form-field     appearance="outline"  >
                <mat-label>Heure de fin PM</mat-label>
                <input matInput  type="time" name="avtHeurePM_Fin" #avtHeurePM_Fin="" [(ngModel)]="data.avtHeurePM_Fin"
                  placeholder="Heure de fin PM" required>
              </mat-form-field>
              
      </form>
     
    </mat-card-content>
  </mat-card>
  </mat-card-content>
  </mat-card>